'use client';

import { FC, PropsWithChildren } from 'react';
import { App as AntdApp, ConfigProvider, type ThemeConfig } from 'antd';
import { observer } from 'mobx-react-lite';
import { useStore } from '@hub/helpers/use-store';

export const AntdProvider: FC<PropsWithChildren> = observer(({ children }) => {
  const { themeStore } = useStore();

  const theme: ThemeConfig = themeStore.getAppThemeConfig();

  return (
    <ConfigProvider theme={theme}>
      <AntdApp>{children}</AntdApp>
    </ConfigProvider>
  );
});
